<template>
  <div id="indicators">
    <div class="clearfix" />

    <h2>Показатели сайта</h2>

    <div class="left">
      <span class="text-gray margin-right sengine-select-divider">|</span>

      <span
        class="type"
        :class="{ 'text-bold': isTypeSelected($getConst('SENGINE_YANDEX')) }"
        :style="{ cursor: !isTypeSelected($getConst('SENGINE_YANDEX')) ? 'pointer' : 'default' }"
        @click="type = $getConst('SENGINE_YANDEX')"
      >
        <img
          src="../../../../../../resources/img/YM.png"
          :class="{ 'img-muted': !isTypeSelected($getConst('SENGINE_YANDEX')) }"
          alt="Яндекс метрика"
        >Яндекс метрика
      </span>

      <span
        class="type"
        :class="{ 'text-bold': isTypeSelected($getConst('SENGINE_GOOGLE')) }"
        style="padding-left: 10px;"
        :style="{ cursor: !isTypeSelected($getConst('SENGINE_GOOGLE')) ? 'pointer' : 'default' }"
        @click="type = $getConst('SENGINE_GOOGLE')"
      >
        <img
          src="../../../../../../resources/img/GA.png"
          :class="{ 'img-muted': !isTypeSelected($getConst('SENGINE_GOOGLE')) }"
          alt="Google Analytics"
        >Google Analytics
      </span>
    </div>

    <div class="right">
      <div class="common-container">
        Страниц в индексе Яндекса: <template v-if="!commonLoading">
          <span
            v-if="!empty(common.yandexIndexCnt)"
            class="text-success text-bold value"
            v-text="common.yandexIndexCnt"
          /><no-data
            v-else
            text="нет данных"
          />
        </template><c-spinner v-else />
      </div>
      <div class="common-container">
        <span class="text-gray margin-left margin-right common-divider">|</span>
        Страниц в индексе Google: <template v-if="!commonLoading">
          <span
            v-if="!empty(common.googleIndexCnt)"
            class="text-success text-bold value"
            v-text="common.googleIndexCnt"
          /><no-data
            v-else
            text="нет данных"
          />
        </template><c-spinner v-else />
      </div>
    </div>

    <div class="clearfix" />

    <c-box
      title="Посещаемость сайта"
      header-divider
    >
      <template v-slot:header="{ title }">
        <h3
          class="box-title"
          v-text="title"
        />
      </template>
      <template v-slot:header-right>
        <div
          v-if="gridMd"
          class="btn-group"
        >
          <button
            v-for="(key, value) in visitsMonthsOptions"
            :key="key"
            class="btn"
            :class="{ 'btn-warning': visitsMonths === parseInt(value) }"
            @click="visitsMonths = parseInt(value)"
          >
            {{ key }}
          </button>
        </div>
        <c-select
          v-else
          v-model="visitsMonths"
          :options="visitsMonthsOptions"
        />
      </template>
      <div class="overlay-wrapper margin-bottom">
        <c-line-chart
          v-if="getMetrics($getConst('METRICS_VISITS')).diagram && getMetrics($getConst('METRICS_VISITS')).diagram.length"
          :chart-data="visitsChartData"
          :options="visitsChartOptions"
          :height="visitsChartHeight"
        />
        <no-data v-else />
        <c-loading-overlay v-show="isMetricsLoading($getConst('METRICS_VISITS'))" />
      </div>
      <div class="metrics">
        <div class="container-fluid source-geo margin-bottom">
          <div class="row">
            <div class="col-lg-6">
              <metrics
                title="Источники трафика"
                :metrics="$getConst('METRICS_SOURCES')"
                :type="type"
              >
                <template v-slot="{ diagram, table }">
                  <div class="row">
                    <div class="col-md-6">
                      <metrics-table
                        v-if="table.length"
                        :data="table"
                      />
                      <no-data v-else />
                    </div>
                    <div class="col-md-6">
                      <template v-if="diagram.length">
                        <c-doughnut-chart
                          class="doughnut-chart"
                          :chart-data="getDiagramPieChartData(diagram)"
                          :options="diagramChartOptions"
                        />
                      </template>
                      <no-data v-else />
                    </div>
                  </div>
                </template>
              </metrics>
            </div>
            <div class="col-lg-6">
              <metrics
                title="География"
                :metrics="$getConst('METRICS_GEO')"
                :type="type"
              >
                <template v-slot="{ diagram, table }">
                  <div class="row">
                    <div class="col-lg-6">
                      <metrics-table
                        v-if="table.length"
                        :data="table"
                      />
                      <no-data v-else />
                    </div>
                    <div class="col-lg-6">
                      <template v-if="diagram.length">
                        <c-doughnut-chart
                          class="doughnut-chart"
                          :chart-data="getDiagramPieChartData(diagram)"
                          :options="diagramChartOptions"
                        />
                      </template>
                      <no-data v-else />
                    </div>
                  </div>
                </template>
              </metrics>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <metric-traffic-devices />
          </div>
          <div class="col-lg-6">
            <metric-traffic-goals />
          </div>
        </div>
      </div>
    </c-box>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'
import CBox from '../../../../../../resources/js/components/ui/CBox'
import CSpinner from '../../../../../../resources/js/components/ui/CSpinner'
import helper from '../../../../../../resources/js/mixins/helper'
import NoData from '../../../../../../resources/js/components/NoData'
import CLineChart from '../../../../../../resources/js/components/ui/CLineChart'
import sengine from '../../../../../../resources/js/mixins/sengine'
import CLoadingOverlay from '../../../../../../resources/js/components/ui/CLoadingOverlay'
import Metrics from '../components/indicators/Metrics'
import CDoughnutChart from '../../../../../../resources/js/components/ui/CDoughnutChart'
import grid from '../../../../../../resources/js/mixins/grid'
import CSelect from '../../../../../../resources/js/components/ui/CSelect'
import diagramColors from '../../../../../../resources/js/mixins/diagramColors'
import MetricsTable from '../../../../../../resources/js/components/MetricsTable.vue'
import MetricTrafficDevices from '../components/indicators/MetricTrafficDevices'
import MetricTrafficGoals from '../components/indicators/MetricTrafficGoals'

export default {
  name: 'Indicators',
  components: {
    MetricsTable,
    CDoughnutChart,
    CLoadingOverlay,
    CLineChart,
    NoData,
    CSpinner,
    CBox,
    Metrics,
    CSelect,
    MetricTrafficDevices,
    MetricTrafficGoals
  },
  mixins: [helper, sengine, grid, diagramColors],
  data () {
    return {
      type: this.$getConst('SENGINE_YANDEX'),
      visitsMonths: 1,
      visitsMonthsOptions: { 1: 'месяц', 2: '2 месяца', 3: '3 месяца', 6: 'пол года', 12: 'год' },
      visitsChartData: {},
      visitsChartOptions: {
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              displayFormats: {
                day: 'D MMMM'
              }
            },
            gridLines: {
              display: false,
              drawBorder: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: 'Визиты'
            }
          }]
        },
        legend: {
          position: 'bottom',
          labels: {
            boxWidth: 7,
            fontStyle: 'bold',
            fontColor: '#282828',
            usePointStyle: true
          }
        },
        elements: {
          point: {
            radius: () => this.visitsChartPointRadius
          }
        },
        plugins: {
          datalabels: {
            display: false
          }
        }
      },
      diagramChartOptions: {
        legend: {
          display: false
        },
        animation: {
          animateScale: true,
          animateRotate: true
        },
        tooltips: {
          callbacks: {
            label (tooltipItem, data) {
              return data.labels[tooltipItem.index] + ': ' + data.datasets[0].data[tooltipItem.index] + '%'
            }
          }
        },
        plugins: {
          datalabels: {
            display: false
          }
        }
      }
    }
  },
  computed: {
    visitsChartHeight () {
      if (this.gridLg) {
        return 80
      }

      if (this.gridMd) {
        return 150
      }

      if (this.gridSm) {
        return 300
      }

      return 500
    },
    visitsChartPointRadius () {
      return this.gridMd ? 3 : 0
    },
    ...mapState({
      domainSelected: state => state.seo.client.domains.selected,
      commonLoading: state => state.seo.project.traffic.common.loading,
      common: state => state.seo.project.traffic.common.statistic
    }),
    ...mapGetters({
      getMetrics: 'seo/project/traffic/metrics/getMetrics',
      isMetricsLoading: 'seo/project/traffic/metrics/isLoading'
    })
  },
  watch: {
    type () {
      this.fetchVisits()
    },
    visitsMonths () {
      this.fetchVisits()
    }
  },
  mounted () {
    if (this.domainSelected) {
      this.fetchAll()
    }

    this.$root.$on('clientDomainsSelectedChange', this.fetchAll)
  },
  destroyed () {
    this.$root.$off('clientDomainsSelectedChange', this.fetchAll)
  },
  methods: {
    isTypeSelected (type) {
      return this.type === type
    },
    fetchAll () {
      this.fetchCommon()
      this.fetchVisits()
    },
    fetchCommon () {
      this.fetchProjectTrafficCommon(this.domainSelected)
    },
    fetchVisits () {
      this.fetchProjectTrafficMetrics({
        domain: this.domainSelected,
        from: moment().subtract(this.visitsMonths, 'months').startOf('months'),
        to: moment().subtract(1, 'months').endOf('months'),
        type: this.type,
        metrics: this.$getConst('METRICS_VISITS')
      })
        .then(data => {
          this.visitsChartData = {
            datasets: [
              {
                label: `${this.getSengineName(this.type)}, результаты поиска`,
                data: data.statistic.diagram.map(i => ({ x: i.name, y: i.visits })),
                fill: false,
                borderColor: '#3eb616',
                lineTension: 0
              }
            ]
          }
        })
    },
    getDiagramPieChartData (diagram) {
      return {
        labels: diagram.map(i => i.name),
        datasets: [
          {
            data: diagram.map(i => i.percent),
            backgroundColor: diagram.map((item, index) => this.getNextDiagramColor(index))
          }
        ]
      }
    },
    ...mapActions({
      fetchProjectTrafficCommon: 'seo/project/traffic/common/fetch',
      fetchProjectTrafficMetrics: 'seo/project/traffic/metrics/fetch'
    })
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

h2 {
  float: left;
  margin-right: 20px;

  @media (max-width: $smBreakpoint) {
    float: none;
  }
}

.left, .right {
  margin-top: 28px;

  @media (max-width: $smBreakpoint) {
    margin-top: 0;
    margin-bottom: 15px;
  }
}

.left {
  margin-right: 20px;
  float: left;

  @media (max-width: $smBreakpoint) {
    margin-right: 0;
    float: none;
  }

  .sengine-select-divider {
    @media (max-width: $smBreakpoint) {
      display: none;
    }
  }
}

.right {
  float: right;

  @media (max-width: $smBreakpoint) {
    float: none;
  }

  .value {
    font-size: 1.3em;
  }

  .common-container {
    float: left;

    @media (max-width: $smBreakpoint) {
      float: none;
    }

    .common-divider {
      @media (max-width: $smBreakpoint) {
        display: none;
      }
    }
  }
}

.type {
  img {
    padding-right: 10px;
    height: 20px;
  }
}

.metrics {
  .source-geo {
    background-color: #f7f7f9;
    padding: 20px;
  }

  .doughnut-chart {
    @media (max-width: $smBreakpoint) {
      width: 50%;
      margin: 0 auto 20px auto;
    }

    @media (max-width: $xsBreakpoint) {
      width: 100%;
    }
  }
}

.visits-months-select-container {
  float: right;

  @media (max-width: $xsBreakpoint) {
    float: none;
    margin-top: 15px;
  }
}

h3.box-title {
  float: left;

  @media (max-width: $xsBreakpoint) {
    float: none;
  }
}
</style>

<style>
  /* глобальные стили */
  #indicators .box {
    overflow-x: auto;
  }
</style>
